import { gql } from "@apollo/client";

export const FETCH_PROCESSES_BY_PROCESS_AREA = gql`
  query findAllProcessesByProcessArea($uuid: ID!) {
    findAll: findAllProcessesByProcessArea(uuid: $uuid) {
      process
      replacementCost
      replacementTime
      uuid
    }
  }
`

export const CREATE_PROCESS = gql`
  mutation CreateProcesses($data: CreateProcessesInput!) {
    createProcesses(data: $data) {
      process
      replacementCost
      replacementTime
      uuid
    }
  }
`;

export const UPDATE_PROCESS = gql`
  mutation UpdateProcesses($data: UpdateProcessesInput!) {
    updateProcesses(data: $data) {
      process
      replacementCost
      replacementTime
      uuid
    }
  }
`;

export const DELETE_PROCESS = gql`
  mutation DeleteProcesses($uuid: ID!) {
    deleteProcesses(uuid: $uuid) {
      process
      replacementCost
      replacementTime
      uuid
    }
  }
`;